import { render, staticRenderFns } from "./CommunicationHistoryGrid.vue?vue&type=template&id=8264da46&scoped=true"
import script from "./CommunicationHistoryGrid.vue?vue&type=script&lang=js"
export * from "./CommunicationHistoryGrid.vue?vue&type=script&lang=js"
import style0 from "./CommunicationHistoryGrid.vue?vue&type=style&index=0&id=8264da46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8264da46",
  null
  
)

export default component.exports